import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../utils/config';

import { Container, Row, Col } from 'react-bootstrap';
import sectionTopBg from '../assets/images/section-top.webp';
import Skeleton from './skeleton/Skeleton';

const SkillsContent = ({ type }) => {
    const [skills, setSkills] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchSkills = async () => {
        try {
            const { data } = await axios.get(API_ENDPOINTS.SKILL_ENDPOINT, {
                headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                },
            });
            return data;
        } catch (error) {
            console.error('Error fetching skills:', error);
            throw error;
        }
    };

    useEffect(() => {
        const loadSkills = async () => {
            setIsLoading(true);
            try {
                const data = await fetchSkills();
                setSkills(data);
            } catch (error) {
                // Optional: toast or logging
            } finally {
                setIsLoading(false);
            }
        };

    loadSkills();
  }, []);

    const renderSkills = () =>
        skills.map(({ id, title, percentage }) => (
            <Col lg={3} md={6} className="wow fadeInUp" key={id}>
                <p className="fw-500 text-start mb-2">{title}</p>
                <div className="progress progress-sm mb-4">
                    <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: `${percentage}%` }}
                        aria-valuenow={percentage}
                        aria-valuemin="0"
                        aria-valuemax="100"
                    />
                </div>
            </Col>
        ));

    return (
        <section id="resume" className="section inner-page">
            <div
                className="section-decoration top"
                style={{
                backgroundImage: `url(${sectionTopBg})`,
                height: '35px',
                backgroundColor: '#f8f9fa',
                }}
            />
            <Container>
                <h2 className="text-6 fw-500 mb-4 pb-2 mt-5 wow fadeInUp text-dark">My Skills</h2>
                <Row className="gx-5">
                    {isLoading ? <Skeleton type="skill" /> : renderSkills()}
                </Row>
            </Container>
        </section>
    );
};

export default SkillsContent;
